import VirtualPageManager from 'navigation/page-manager/VirtualPageManager';
import Component from 'navigation/component/Component';
import PanelPage from 'navigation/pages/PanelPage';
import scroll from 'core/scroll';
import { bindMethod } from 'helpers/bind';
import anime from 'animejs';
import { EASE_OUT } from 'helpers/easings';
import { durations } from 'components/menu/motion';
import store from 'store/store';
class Panel extends Component {
    pageManager;
    opened = false;
    constructor(el, options) {
        super(el, options);
        this.pageManager = new VirtualPageManager(store.panel, el.querySelector('.panel__inner'), '.page', PanelPage);
        store.routers.get().panel = this.pageManager;
    }
    initialized() {
        super.initialized();
        if (this.el.dataset.sessionPanel && this.el.dataset.sessionPanel.length > 0)
            setTimeout(() => { store.panel.set(this.el.dataset.sessionPanel.replace(window.location.origin, '')); });
    }
    bindEvents(add = true) {
        const method = bindMethod(add);
        store.panel.listenAndStart(this.onPanelUpdate);
        this.pageManager.on('loading', this.onLoading);
        this.pageManager.on('loaded', this.onLoaded);
        if (this.refs.panelClose)
            this.refs.panelClose[method]('click', this.onClose);
    }
    onLoading = () => {
        this.el.classList.add('loading');
    };
    onLoaded = () => {
        setTimeout(() => {
            this.el.classList.remove('loading');
        }, 200);
        if (!this.opened)
            this.toggle(true, null);
    };
    onClose = () => {
        store.panel.set(null);
    };
    resize() {
        this.pageManager.resize();
        super.resize();
    }
    onPanelUpdate = (panel, previous) => {
        const notEmpty = !!panel || panel === '';
        if (notEmpty)
            scroll.lock(true);
        else
            scroll.unlock(true);
        if (notEmpty === false)
            this.toggle(notEmpty, previous);
    };
    toggle(state, previous) {
        if (previous === null && state === false)
            return;
        const wrapper = this.el.children[0];
        anime({
            targets: wrapper,
            translateX: {
                value: state ? ['50%', '0'] : ['0', '50%'],
                duration: state ? durations.FIRST_PANEL_TRANSLATE_IN : durations.FIRST_PANEL_TRANSLATE_OUT,
                easing: state ? EASE_OUT : 'easeInSine'
            },
            opacity: {
                value: state ? [0, 1] : [1, 0],
                duration: state ? durations.FIRST_PANEL_OPACITY_IN : durations.FIRST_PANEL_OPACITY_OUT,
                delay: state ? 0 : durations.FIRST_PANEL_OPACITY_OUT / 2,
                easing: 'linear'
            },
            begin: () => {
                if (state) {
                    wrapper.style.visibility = 'visible';
                    this.opened = true;
                }
            },
            complete: () => {
                if (!state) {
                    wrapper.style.visibility = 'hidden';
                    this.opened = false;
                    wrapper.children[0].removeAttribute('style');
                }
            }
        });
    }
}
export default Panel;
